import { createVehicleSelectionViews } from '../../shared/vehicleSelection/VehicleSelectionViews';
import type { VehicleSelectionConfig } from '../../shared/vehicleSelection/vehicleSelection.types';
import { getCoastEligibleVehiclesColumns } from './coastEligibleVehicles.columns';

export const coastVehicleSelectionConfig: VehicleSelectionConfig = {
  providerCode: 'COAST',
  columns: getCoastEligibleVehiclesColumns,
  testIdPrefix: 'coast-eligible-vehicles',
};

export const {
  ViewVehiclesSubView: CoastViewVehiclesSubView,
  SelectVehiclesSubView: CoastSelectVehiclesSubView,
} = createVehicleSelectionViews(coastVehicleSelectionConfig);
